import { GradientPath } from './GradientPath';

type Props = {
  className?: string;
};

export const Payment = ({ className }: Props) => {
  return (
    <GradientPath
      className={className}
      height={28}
      width={36}
      render={(id) => (
        <path
          fill={`url(#${id})`}
          d="m31.75 0a2.77 2.77 0 0 1 2 .85 2.8 2.8 0 0 1 .85 2v22a2.9 2.9 0 0 1 -2.89 2.9h-28.82a2.78 2.78 0 0 1 -2-.85 2.8 2.8 0 0 1 -.85-2v-22a2.81 2.81 0 0 1 .85-2 2.78 2.78 0 0 1 2-.85zm-29.65 1.69a.58.58 0 0 0 -.43.18.59.59 0 0 0 -.18.43v4.28h31.65v-4.28a.58.58 0 0 0 -.14-.43.58.58 0 0 0 -.43-.18zm30.43 24.44a.62.62 0 0 0 .61-.61v-17.07h-31.64v17.07a.6.6 0 0 0 .18.43.6.6 0 0 0 .43.18zm-28.6-2.45v-1.05h4.87v1.06zm7.3 0v-1h7.3v1z"
        />
      )}
    />
  );
};
